import type { GatewayActionDef, GatewayRouter } from './api';

/**
 * The action as it applies to one gateway. Only "status" differs: a gateway
 * whose SMS rule authorizes by password is texted "<password> status" rather
 * than "<serial> status". Mirrors `actionForGateway` in api/src/lib/gateways.ts,
 * which decides what is actually sent.
 */
export function actionForGateway(action: GatewayActionDef, router: GatewayRouter): GatewayActionDef {
  if (action.id !== 'status' || !action.sms || router.smsStatusAuth !== 'password') return action;
  return { ...action, sms: { ...action.sms, needsPassword: true, preview: '<password> status' } };
}

/** Whether the SMS version can be sent to this gateway at all. */
export function smsUsable(action: GatewayActionDef, router: GatewayRouter): boolean {
  if (!action.sms || !router.smsReachable) return false;
  // Serial-authorized status needs a serial from RMS.
  return action.sms.id !== 'sms.status' || action.sms.needsPassword || Boolean(router.serial);
}
